module.exports = __webpack_public_path__ + "static/media/dp-logo-watermark-color.01a22071.png";